<template><section><h2>其他</h2>
<h4>负值图</h4>
<block-demo tip="" source="const data = [
  {
    product: &quot;05-08&quot;,
    year: &quot;图例一&quot;,
    sales: 3000,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例二&quot;,
    sales: -1000,
  },
  {
    product: &quot;05-08&quot;,
    year: &quot;图例三&quot;,
    sales: 2000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例一&quot;,
    sales: 3000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例二&quot;,
    sales: -1000,
  },
  {
    product: &quot;05-09&quot;,
    year: &quot;图例三&quot;,
    sales: -2000,
  },

  {
    product: &quot;05-10&quot;,
    year: &quot;图例一&quot;,
    sales: -1700,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例二&quot;,
    sales: 2400,
  },
  {
    product: &quot;05-10&quot;,
    year: &quot;图例三&quot;,
    sales: 3700,
  },

  {
    product: &quot;05-11&quot;,
    year: &quot;图例一&quot;,
    sales: 4200,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例二&quot;,
    sales: 2800,
  },
  {
    product: &quot;05-11&quot;,
    year: &quot;图例三&quot;,
    sales: 3100,
  },

  {
    product: &quot;05-12&quot;,
    year: &quot;图例一&quot;,
    sales: 5100,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例二&quot;,
    sales: 2500,
  },
  {
    product: &quot;05-12&quot;,
    year: &quot;图例三&quot;,
    sales: -350,
  },
]
const { Chart, PolarBar, Tooltip, Legend } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  row: &quot;year&quot;,
  value: &quot;sales&quot;,
  text: &quot;product&quot;,
})
const bar = new PolarBar({
  innerRadius: 0.1,
  radius: 0.9,
  groupPadAngle: 10,
})
const tooltip = new Tooltip()
const legend = new Legend()

chart.append([bar, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-1000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-08"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-1000</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-09"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-2000</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-1700</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2400</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-10"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3700</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">4200</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2800</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-11"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">3100</span>,
  },

  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例一"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">5100</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例二"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">2500</span>,
  },
  {
    <span class="hljs-attr">product</span>: <span class="hljs-string">"05-12"</span>,
    <span class="hljs-attr">year</span>: <span class="hljs-string">"图例三"</span>,
    <span class="hljs-attr">sales</span>: <span class="hljs-number">-350</span>,
  },
]
<span class="hljs-keyword">const</span> { Chart, PolarBar, Tooltip, Legend } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">"year"</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">"sales"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"product"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> PolarBar({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.1</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.9</span>,
  <span class="hljs-attr">groupPadAngle</span>: <span class="hljs-number">10</span>,
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()

chart.append([bar, tooltip, legend])
</code></pre>
</block-demo><h4>彩色样式</h4>
<block-demo tip="" source="const data = [
  { value: 6100, label: &quot;TOP1&quot; },
  { value: 5200, label: &quot;TOP2&quot; },
  { value: 4400, label: &quot;TOP3&quot; },
  { value: 3700, label: &quot;TOP4&quot; },
  { value: 2800, label: &quot;TOP5&quot; },
  { value: 3000, label: &quot;TOP6&quot; },
  { value: 5300, label: &quot;TOP7&quot; },
  { value: 3400, label: &quot;TOP8&quot; },
]
const colors = [
  &quot;#47A1FF&quot;,
  &quot;#59CB74&quot;,
  &quot;#FFB952&quot;,
  &quot;#FC6980&quot;,
  &quot;#6367EC&quot;,
  &quot;#DA65CC&quot;,
  &quot;#FBD54A&quot;,
  &quot;#ADDF84&quot;,
]
const { Chart, PolarBar, Tooltip } = qcharts
const chart = new Chart({
  container: &quot;#app&quot;,
})
chart.source(data, {
  value: &quot;value&quot;,
  text: &quot;label&quot;,
})
const bar = new PolarBar({
  innerRadius: 0.1,
  radius: 0.8,
}).style(&quot;pillar&quot;, (attr, data, i) =&gt; {
  return { fillColor: colors[i] }
})
const tooltip = new Tooltip().style(&quot;point&quot;, (attr, item, i) =&gt; {
  return { &quot;background-color&quot;: colors[data.indexOf(item[0])] }
})
chart.append([bar, tooltip])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">6100</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP1"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">5200</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP2"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">4400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP3"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3700</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP4"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2800</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP5"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3000</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP6"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">5300</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP7"</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3400</span>, <span class="hljs-attr">label</span>: <span class="hljs-string">"TOP8"</span> },
]
<span class="hljs-keyword">const</span> colors = [
  <span class="hljs-string">"#47A1FF"</span>,
  <span class="hljs-string">"#59CB74"</span>,
  <span class="hljs-string">"#FFB952"</span>,
  <span class="hljs-string">"#FC6980"</span>,
  <span class="hljs-string">"#6367EC"</span>,
  <span class="hljs-string">"#DA65CC"</span>,
  <span class="hljs-string">"#FBD54A"</span>,
  <span class="hljs-string">"#ADDF84"</span>,
]
<span class="hljs-keyword">const</span> { Chart, PolarBar, Tooltip } = qcharts
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">"#app"</span>,
})
chart.source(data, {
  <span class="hljs-attr">value</span>: <span class="hljs-string">"value"</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">"label"</span>,
})
<span class="hljs-keyword">const</span> bar = <span class="hljs-keyword">new</span> PolarBar({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.1</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.8</span>,
}).style(<span class="hljs-string">"pillar"</span>, (attr, data, i) =&gt; {
  <span class="hljs-keyword">return</span> { <span class="hljs-attr">fillColor</span>: colors[i] }
})
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip().style(<span class="hljs-string">"point"</span>, (attr, item, i) =&gt; {
  <span class="hljs-keyword">return</span> { <span class="hljs-string">"background-color"</span>: colors[data.indexOf(item[<span class="hljs-number">0</span>])] }
})
chart.append([bar, tooltip])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>